// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jnll-","field":"styles_field__2Bs4M","fieldCol":"styles_fieldCol__2hCl5","diffCol":"styles_diffCol__1Aoy0","diff":"styles_diff__27BFi"};